/**
 * useStreak - Hook for streak tracking
 */

import { useState, useEffect, useCallback } from 'react';
import { streakService } from '../services/StreakService';

export function useStreak() {
  const [status, setStatus] = useState(null);
  const [milestones, setMilestones] = useState(null);
  const [calendar, setCalendar] = useState([]);
  const [activityStats, setActivityStats] = useState(null);

  const refreshStreak = useCallback(() => {
    setStatus(streakService.getStreakStatus());
    setMilestones(streakService.getStreakMilestones());
    setActivityStats(streakService.getActivityStats());
    
    // Get current month calendar
    const now = new Date();
    setCalendar(streakService.getStreakCalendar(now.getFullYear(), now.getMonth()));
  }, []);

  useEffect(() => {
    refreshStreak();
  }, [refreshStreak]);

  const recordActivity = useCallback(() => {
    const result = streakService.recordActivity();
    streakService.markDayActive();
    refreshStreak();
    return result;
  }, [refreshStreak]);

  const getCalendarForMonth = useCallback((year, month) => {
    return streakService.getStreakCalendar(year, month);
  }, []);

  return {
    status,
    milestones,
    calendar,
    activityStats,
    
    // Actions
    recordActivity,
    refreshStreak,
    getCalendarForMonth,
    
    // Quick accessors
    currentStreak: status?.currentStreak || 0,
    longestStreak: status?.longestStreak || 0,
    isActive: status?.isActive || false,
    activeToday: status?.activeToday || false,
    needsActivityToday: status?.willExpireToday && !status?.activeToday,
    nextMilestone: milestones?.nextMilestone,
    daysToNextMilestone: milestones?.daysToNextMilestone || 0,
    consistency: activityStats?.consistency || 0,
    totalDaysActive: status?.totalDaysActive || 0
  };
}

export default useStreak;